import { render, staticRenderFns } from "./RentaBitacora.vue?vue&type=template&id=35221126&"
import script from "./RentaBitacora.vue?vue&type=script&lang=js&"
export * from "./RentaBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports